<button
  *ngIf="visible()"
  type="button"
  class="onb-fab"
  (click)="open()"
  [attr.aria-label]="
    remainingCount() > 0
      ? ('onboarding.fab.aria_with_count' | transloco: { count: remainingCount() })
      : ('onboarding.fab.aria_without_count' | transloco)
  "
>
  <span class="onb-fab-ring" aria-hidden="true"></span>
  <span class="onb-fab-icon material-icons-outlined">rocket_launch</span>
  <span class="onb-fab-progress" aria-hidden="true">
    {{ progress() }}%
  </span>
  <span
    *ngIf="remainingCount() > 0"
    class="onb-fab-badge"
    aria-hidden="true"
  >
    {{ remainingCount() > 9 ? '9+' : remainingCount() }}
  </span>
</button>
